import React from 'react'
import { Box, Grid, Paper, Typography } from '@material-ui/core'

import constants from 'constants/index'

import useStyles from './styles'

const Cards = () => {
  const classes = useStyles()

  const { LARGE_SCALE_CARDS } = constants.incidentHighRisk

  return (
    <Box className={classes.container}>
      <Grid container spacing={2}>
        {LARGE_SCALE_CARDS.map((card) => (
          <Grid item xs={12} sm={6} md={4} key={card.id}>
            <Paper variant="outlined" className={classes.card}>
              <Box className={classes.cardContent}>
                <Box className={classes.cardHeader}>
                  <Box className={classes.cardNumber}>
                    <Typography
                      variant="subtitle1"
                      className={classes.cardNumberText}
                    >
                      {card.id}
                    </Typography>
                  </Box>
                  <Typography variant="h3">{card.name}</Typography>
                </Box>
                <Typography variant="body1">{card.text}</Typography>
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}

export default Cards
